var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list',{attrs:{"hide-delete":"","hide-edit":"","hide-select":"","api-debounce-time":500,"headers":"utility_code,client_N,client_type,client_name,client_phone,client_phone2,client_email","filter":_vm.filter,"item-class":()=>'cursor-pointer'},on:{"click:row":_vm.clickRow}})
}
var staticRenderFns = []

export { render, staticRenderFns }